<script setup lang="ts">
import { defineProps } from "vue";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useRouter } from "vue-router";
import GradientButton from "@/components/buttons/GradientButton.vue";
import { useI18n } from "vue-i18n";

const props = defineProps<{
  cardTitle: string;
  cardText: string;
  calculatorRoute: (typeof ROUTE_NAMES)[keyof typeof ROUTE_NAMES];
}>();

const router = useRouter();
const { t } = useI18n();

function openCalculator() {
  router.push({ name: props.calculatorRoute });
}
</script>

<template>
  <div
    class="bg-white rounded-[20px] text-center flex flex-col justify-between h-auto md:h-[360px] lg:md:h-[336px] w-full md:w-[502px] px-10 py-6"
  >
    <h4 class="text-2xl font-semibold leading-[32px] text-brown mb-10">
      {{ cardTitle }}
    </h4>
    <p class="text-base leading-[20px] text-black mb-10 text-left">
      {{ cardText }}
    </p>
    <div class="flex justify-center">
      <GradientButton
        class="w-[169px] h-14"
        bg-color="bg-brown-gradient"
        hover-bg-color="bg-orange-gradient"
        :text="t('buttons.go')"
        @click="openCalculator"
      />
    </div>
  </div>
</template>

<style scoped></style>
